"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.truckRef = exports.Truck = void 0;
var mobx_keystone_1 = require("mobx-keystone");
var Truck = /** @class */ (function (_super) {
    __extends(Truck, _super);
    function Truck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return "".concat(_this.id); };
        return _this;
    }
    Truck = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/Truck')
    ], Truck);
    return Truck;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    name: (0, mobx_keystone_1.prop)(),
    vehicleType: (0, mobx_keystone_1.prop)(),
    terminal: (0, mobx_keystone_1.prop)(),
})));
exports.Truck = Truck;
exports.truckRef = (0, mobx_keystone_1.rootRef)('doc-mate/TruckRef', {
    getId: function (target) {
        if (target instanceof Truck) {
            return "".concat(target.id);
        }
    },
});
